import { apiClient } from '@/shared/api';
import type {
  EripDepositResponse,
  OplatiDepositResponse,
} from '@/shared/types';
import { handleRequest } from '@/shared/api/apiWrapper';

export const getOplatiDeposit = async (): Promise<OplatiDepositResponse> => {
  const request = () => apiClient.get('/operations/oplati/deposit');
  const response = await handleRequest(request);

  return response.data;
};

export const getEripDeposit = async (): Promise<EripDepositResponse> => {
  const request = () => apiClient.get('/operations/erip/deposit');
  const response = await handleRequest(request);

  return response.data;
};
